import { required } from './required';
import { email } from './email';
import { maxFileSize } from './maxFileSize';
export const validations = {
    required,
    email,
    maxFileSize
};
//# sourceMappingURL=index.js.map